import { Controller } from "@hotwired/stimulus";
import { isZipFile } from "../../utils/file_utils";
import { FILE_ACCEPTED_FORMATS, ZIP_ACCEPTED_FORMAT } from "../../utils/constants";
import { toggleClass } from "../../utils/misc";
import $ from "jquery";

const ACCEPTED_FORMATS = `${FILE_ACCEPTED_FORMATS}, ${ZIP_ACCEPTED_FORMAT}`;
const MAX_FILES = 12;

export default class extends Controller {
  static targets = ["submitBtn", "removeAllFilesBtn"];
  static outlets = ["basic-file-upload"];

  connect() {
    this.dropzone = this.basicFileUploadOutlet.dropzone;

    this._initDropzoneEvents();
  }

  validateSubmission(e) {
    if (this._isValidForm()) {
      e.preventDefault();
      this.dropzone.processQueue();
    }
  }

  _isValidForm() {
    return $(this.submitBtnTarget.form).parsley().isValid();
  }

  removeAllFiles() {
    this.dropzone.removeAllFiles(true);
  }

  _initDropzoneEvents() {
    this.dropzone.on("processing", () => {
      this._defineDropzoneUrl();
    });

    this.dropzone.on("addedfile", () => {
      this._toggleUploadElements();
      this._defineOptions();
    });

    this.dropzone.on("removedfile", () => {
      this._toggleUploadElements();
      this._defineOptions();
    });

    this.dropzone.on("successmultiple", (e, response) => {
      if (this.isZipUpload) {
        location.reload();
      } else {
        Turbo.renderStreamMessage(response);

        document.dispatchEvent(new CustomEvent("purchaseInvoices:filesUploaded"));
      }
    });
  }

  _toggleUploadElements() {
    const acceptedFiles = this.dropzone.files.length;
    const hasAcceptedFile = acceptedFiles > 0;
    const hasManyAcceptedFiles = acceptedFiles > 1;
    toggleClass(this.submitBtnTarget, "hidden", hasAcceptedFile);
    toggleClass(this.removeAllFilesBtnTarget, "hidden", hasManyAcceptedFiles);
  }

  _defineOptions() {
    let options = {};
    this.isZipUpload = false;

    if (this.dropzone.files.length === 0) {
      options = {
        acceptedFiles: ACCEPTED_FORMATS,
        maxFiles: MAX_FILES,
        maxFilesize: 10,
      };
    } else if (isZipFile(this.dropzone.files[0])) {
      this.isZipUpload = true;

      options = {
        acceptedFiles: ZIP_ACCEPTED_FORMAT,
        maxFiles: 1,
        maxFilesize: 100,
      };
    } else {
      options = {
        acceptedFiles: FILE_ACCEPTED_FORMATS,
        maxFiles: MAX_FILES,
        maxFilesize: 10,
      };
    }

    this.dropzone.options = { ...this.dropzone.options, ...options };
  }

  _defineDropzoneUrl() {
    if (this.isZipUpload) {
      this.dropzone.options.url = this.dropzone.element.dataset.zipUploadUrl;
    } else {
      this.dropzone.options.url = this.dropzone.element.dataset.fileUploadUrl;
    }
  }
}
